<div class="excel">
  <div class="excel__actions">
    <button class="btn-icon" (click)="create()">
      <mat-icon svgIcon="download" class="icon-32"></mat-icon>
      Hent listen
    </button>
    <button class="btn-icon" [class.active]="displayUpload" (click)="toggleUpload()">
      <mat-icon svgIcon="upload" class="icon-32"></mat-icon>
      Masseskifte
    </button>
  </div>

  @if (displayUpload) {
    <div class="excel__upload">
      @if (uploadInprogress) {
        <div>
          <p class="orange med-text align-center">
            <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
            <br />
            <span>Vent venligst</span>
          </p>
          <div class="flex margin--top-l margin--bottom-l align-center">
            <div class="loading loading--dark"></div>
          </div>
        </div>
      } @else {
        <div
          class="excel__dropzone"
          (click)="fileInput.click()"
          (drop)="handleDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          [class.excel__dropzone--dragover]="displayFileDrag"
          >
          <input style="display: none" type="file" accept=".xlsx" #fileInput (change)="chooseFile(fileInput.files)" />
          <mat-icon svgIcon="add-document" class="icon-48 margin--bottom-xs"></mat-icon>
          <span class="excel__dropzone-cta">Vælg den .xlsx fil du vil uploade</span>
          <span>eller træk filen hertil</span>
        </div>
        @if (selectedFile && !uploaderrors?.length) {
          <div class="icon-with-text green bold">
            <mat-icon svgIcon="checkmark-circle" class="icon-48"></mat-icon>
            {{ selectedFile?.name }} indlæst
          </div>
        }
        @if (selectedFile && uploaderrors?.length) {
          <div class="icon-with-text red bold">
            <mat-icon svgIcon="alert-solid" class="icon-48"></mat-icon>
            {{ selectedFile?.name }} indlæst med {{ uploadsummarykeys(uploaderrorssummary).length }}
            @if (uploadsummarykeys(uploaderrorssummary).length > 1) {
              <span>forskellige</span>
            }
            <span>type</span>
            @if (uploadsummarykeys(uploaderrorssummary).length > 1) {
              <span>r</span>
            }
            fejl
          </div>
        }
        <div class="excel__summary">
          <ul>
            @for (error of uploadsummarykeys(uploaderrorssummary); track error) {
              <li class="excel__summary-item excel__summary-item--error">
                @if (error.value != 0) {
                  <span>{{ error.value }} række med fejlen: {{ error.key }}</span>
                } @else {
                  {{ error.key }}
                }
                <ul class="excel__summary-details">
                  @for (aftale of uploadresultformessage(error.key); track aftale) {
                    <li>#{{ aftale.id }}</li>
                  }
                </ul>
              </li>
            }
          </ul>
          <ul>
            @for (value of uploadsummarykeys(uploadwarningssummary); track value) {
              <li class="excel__summary-item excel__summary-item--warning">
                {{ value.value }} række med advarsel: {{ value.key }}
                <ul class="excel__summary-details">
                  @for (aftale of uploadresultformessage(value.key); track aftale) {
                    <li>#{{ aftale.id }}</li>
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
  @for (value of uploadsummarykeys(uploadsuccesssummary); track value) {
    <div class="excel__message excel__message--success">
      <span class="icon-with-text">
        <mat-icon svgIcon="checkmark-circle" class="icon-32"></mat-icon>
        {{ value.value }} vil blive skiftet til {{ value.key }}
      </span>
    </div>
  }
  <div class="excel__upload-button">
    @if (displayUpload) {
      <button
        mat-raised-button
        color="primary"
        (click)="sendExcel()"
        [disabled]="!selectedFile || !!uploaderrors.length || !!uploadInprogress"
        >
        <mat-icon svgIcon="upload"></mat-icon>
        Gennemfør ændringer
      </button>
    }
  </div>
  @if (ShowDownloadCta) {
    <div class="excel__message excel__message--warning">
      <span class="icon-with-text">
        <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
        {{ ShowDownloadCta }}
      </span>
    </div>
  }
</div>
